import { gql } from 'react-apollo';

export default gql`
  query offerInvestments($offerId: ID!) {
    offerInvestments(offerId: $offerId) {
      _id
      createdAt
      investmentStatus
      investmentAmount
      investmentAmountCrypto
      paymentMethod
      paymentType
      paymentSent
      sharesOrTokensPurchased
      investmentReviewAgreement
      closingDateAgreement
      crowdfundingQuestion
      crowdfundingAmount
      toggleSecondSigner
      secondSignerEmail
      countryOfResidence
      confirmCountryOfResidence
      typeOfInvestment
      investmentTypeDocument
      entityType
      secondSignerName
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/offerInvestments.js